import {
  Card,
  CardMedia,
  Box,
  CardContent,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import { PrizeDto } from "../../models/Lottery";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { usePrize } from "../../hooks/usePrize";

export const PrizeCard = ({
  prize,
  lotteryTitle,
}: {
  prize: PrizeDto;
  lotteryTitle: string;
}) => {
  const { deletePrize } = usePrize(undefined);

  const handleDelete = async () => {
    if (!prize.id) return;
    const confirmed = window.confirm(
      "Είσαι σίγουρος ότι θέλεις να διαγράψεις αυτό το δώρο;"
    );
    if (!confirmed) return;

    await deletePrize(prize.id);
    window.location.reload();
  };

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        border: "2px solid hsl(30, 20%, 85%)",
        transition: "all 0.3s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 40px -12px rgba(0,0,0,0.15)",
          borderColor: "hsl(45, 90%, 50%)",
        },
      }}
    >
      {prize.image ? (
        <CardMedia
          component="img"
          height={120}
          sx={{ objectFit: "fill", userSelect: "none" }}
          image={prize.image ? `data:image/jpeg;base64,${prize.image}` : ""}
          alt="Manufacturer Logo"
        />
      ) : (
        <Box
          sx={{
            height: 120,
            background:
              "linear-gradient(135deg, hsl(45, 90%, 50%) 0%, hsl(45, 85%, 60%) 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CardGiftcardIcon sx={{ fontSize: 64, color: "white" }} />
        </Box>
      )}
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: '"Mountains of Christmas", cursive',
            color: "hsl(150, 60%, 25%)",
            mb: 1,
          }}
        >
          {prize.name}
        </Typography>
        <Typography
          sx={{
            color: "hsl(150, 20%, 35%)",
            mb: 2,
            fontSize: "0.9rem",
          }}
        >
          {prize.description}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "hsl(350, 80%, 40%)", fontWeight: 600 }}
          >
            Ποσότητα: {prize.quantity}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "hsl(150, 60%, 25%)",
              fontSize: "0.8rem",
            }}
          >
            {lotteryTitle}
          </Typography>
        </Box>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2, pt: 0 }}>
        <Button
          component={Link}
          to={`/prizes/${prize.id}`}
          size="small"
          startIcon={<EditIcon />}
          sx={{ color: "hsl(150, 60%, 25%)" }}
        >
          Επεξεργασία
        </Button>
        <Button
          size="small"
          onClick={handleDelete}
          startIcon={<DeleteIcon />}
          sx={{ ml: "auto", color: "hsl(0, 60%, 50%)" }}
        >
          Διαγραφη
        </Button>
      </CardActions>
    </Card>
  );
};
